import { ChangeDetectionStrategy, Component, computed, effect, inject, OnInit, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HorizontalScrollComponent, TitleSummaryComponent } from '@client-monorepo/common/ui-components';
import { NgxChipComponent } from '@digipay/ngx-chip';
import { rangeCreator } from '@client-monorepo/common/utilities';
import { SearchHistoryService } from '../../data-access/services/search-history.service';

@Component({
  selector: 'stores-applet-search-history',
  standalone: true,
  imports: [CommonModule, HorizontalScrollComponent, NgxChipComponent, TitleSummaryComponent],
  templateUrl: './search-history.component.html',
  styleUrl: './search-history.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchHistoryComponent {
  rangeCreator = rangeCreator;
  searchHistoryService = inject(SearchHistoryService);
  historyLoading = computed<boolean>(() => {
    return this.searchHistoryService.historyLoading();
  });
  searchHistory = computed<Array<string>>(() => {
    return this.searchHistoryService.searchHistory();
  });
  itemClicked = output<string>();
  hasHistory = output<boolean>();
  constructor() {
    effect(() => {
      if (!this.historyLoading()) {
        this.hasHistory.emit(!!this.searchHistory().length);
      }
    });
  }
  itemClickedHandle(itemText: string): void {
    this.itemClicked.emit(itemText);
  }

  removeHistory(): void {
    this.searchHistoryService.clearHistory();
  }
}
